import api from "../api/flexapi";
import { transformBenefitsPayload } from "reducers/riskmedicalReducer";

export const riskmedicalLoadBegin = "riskmedicalLoadBegin";
export const riskmedicalLoadSuccess = "riskmedicalLoadSuccess";
export const riskmedicalLoadFailed = "riskmedicalLoadFailed";
export const riskmedicalSaveBegin = "riskmedicalSaveBegin";
export const riskmedicalSaveSuccess = "riskmedicalSaveSuccess";
export const riskmedicalSaveFailed = "riskmedicalSaveFailed";
export const riskmedicalSelectDefaultLastAcceptedCover =
  "riskmedicalSelectDefaultLastAcceptedCover";
export const riskmedicalBenefitPlanFilter = "riskmedicalBenefitPlanFilter";
export const riskmedicalBenefitPlan = "riskmedicalBenefitPlan";
export const riskmedicalEnrolmentDone = "riskmedicalEnrolmentDone";
export const riskmedicalCleanState = "riskmedicalCleanState";
export const riskmedicalPerMemberSelection = "RISKMEDICAL_PER_MEMBER_SELECTION";

// Call API to load module data
export function load() {
  // Return thunk middleware
  return dispatch => {
    dispatch({ type: riskmedicalLoadBegin, payload: null });

    api
      .getEnrolment()
      .then(response => {
        dispatch({
          type: riskmedicalLoadSuccess,
          payload: transformBenefitsPayload(response.body),
        });
      })
      .catch(err => {
        dispatch({
          type: riskmedicalLoadFailed,
          payload: err.response ? err.response.body : err,
        });
      });

    // api.dummyApiCall({ type: "enrolment-no-coverage" }).then(response => {
    //   dispatch({ type: riskmedicalLoadSuccess, payload: response.body });
    // }).catch(err => {
    //   dispatch({ type: riskmedicalLoadFailed, payload: err.response ? err.response.body : err });
    // });
  };
}

// Call API to load module data
export function save(data, checkout) {
  // Return thunk middleware
  return dispatch => {
    dispatch({ type: riskmedicalSaveBegin, payload: null });

    api
      .saveEnrolment({
        Benefits: data,
        OtherBenefits: [],
      })
      .then(response => {
        // When save enrolment is successful, trigger the re-caching of enrolment data to make sure that
        // cache is available by the time user navigates back to enrolment page.
        api.cacheEnrolment();

        dispatch({
          type: riskmedicalSaveSuccess,
          payload: { response: response.body, isCheckout: checkout },
        });
      })
      .catch(err => {
        dispatch({
          type: riskmedicalSaveFailed,
          payload: err.response ? err.response.body : err,
        });
      });
  };
}

export function selectDefaultLastAcceptedCover(data) {
  return dispatch =>
    dispatch({
      type: riskmedicalSelectDefaultLastAcceptedCover,
      payload: data,
    });
}

export function riskmedicalChangeBenefitPlanFilter(benefitId, filterData) {
  return dispatch =>
    dispatch({
      type: riskmedicalBenefitPlanFilter,
      payload: { benefit: benefitId, filter: filterData },
    });
}

export function riskmedicalChangeBenefitPlan(benefitData, planData) {
  return dispatch =>
    dispatch({
      type: riskmedicalBenefitPlan,
      payload: { benefit: benefitData, plan: planData },
    });
}

export function riskmedicalMarkEnrolmentAsDone() {
  return dispatch => dispatch({ type: riskmedicalEnrolmentDone, payload: null });
}

export function clean() {
  return dispatch => dispatch({ type: riskmedicalCleanState });
}

export function onChangePerMemberSelection(benefit, plan) {
  return {
    type: riskmedicalPerMemberSelection,
    payload: {
      benefit,
      plan,
    },
  };
}



// WEBPACK FOOTER //
// ./actions/riskmedicalActions.jsx